<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
      action-buttons-name="TransferenciasJugadoresActionButtons" filter
      search-text="Buscar nombre de jugador" :search="search" toolbar toolbar-title="Jugadores transferidos" :borderRadius="true" :toolBarNotAbsolute="true">
      <slot slot="toolbar-table"></slot>

    </DataTable>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {

  components: {
    DataTable
  },

  data () {
    return {
      path: 'finished-contracts',
      filterPath: 'filters/finished-contracts',
      search: null,
      searchText: 'Buscar jugador'
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Club vendedor', value: 'clubFrom', filterField: true, sortable: true },
        { text: 'Jugador', value: 'player' },
        { text: 'Club comprador', value: 'clubTo', filterField: true },
        { text: 'Fecha de cierre de contrato', value: 'closeDate' },
        { text: 'Desde Fecha de Cierre', value: 'fromDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Hasta Fecha de cierre', value: 'toDate', sortable: false, align: 'right', dateFilterField: true, visible: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      return headers
    },
    properties () {
      let properties = ['clubFrom', 'player', 'clubTo', 'closeDate']
      return properties
    }
  },

  methods: {

  }
}
</script>
